import React from 'react';
import { DateRange } from '../types';

interface DateRangePickerProps {
  dateRange: DateRange;
  onDateRangeChange: (dateRange: DateRange) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ dateRange, onDateRangeChange }) => {
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onDateRangeChange({
      ...dateRange,
      startDate: e.target.value
    });
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onDateRangeChange({
      ...dateRange,
      endDate: e.target.value
    });
  };

  const setYearToDate = () => {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    
    onDateRangeChange({
      startDate: startOfYear.toISOString().split('T')[0],
      endDate: now.toISOString().split('T')[0]
    });
  };

  const setLast30Days = () => {
    const now = new Date();
    const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
    
    onDateRangeChange({
      startDate: thirtyDaysAgo.toISOString().split('T')[0],
      endDate: now.toISOString().split('T')[0]
    });
  };

  const setLast90Days = () => {
    const now = new Date();
    const ninetyDaysAgo = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
    
    onDateRangeChange({
      startDate: ninetyDaysAgo.toISOString().split('T')[0],
      endDate: now.toISOString().split('T')[0]
    });
  };

  return (
    <div className="flex items-center space-x-3 text-xs text-gray-600">
      <span>Date range:</span>
      <input
        type="date"
        value={dateRange.startDate}
        onChange={handleStartDateChange}
        className="px-2 py-1 border border-gray-300 rounded text-xs"
      />
      <span>to</span>
      <input
        type="date"
        value={dateRange.endDate}
        onChange={handleEndDateChange}
        className="px-2 py-1 border border-gray-300 rounded text-xs"
      />
      <div className="flex space-x-1 ml-2">
        <button
          onClick={setYearToDate}
          className="px-2 py-1 text-xs text-blue-600 hover:text-blue-800"
        >
          YTD
        </button>
        <button
          onClick={setLast90Days}
          className="px-2 py-1 text-xs text-gray-500 hover:text-gray-700"
        >
          90d
        </button>
        <button
          onClick={setLast30Days}
          className="px-2 py-1 text-xs text-gray-500 hover:text-gray-700"
        >
          30d
        </button>
      </div>
    </div>
  );
};

export default DateRangePicker;
